import { defineSlotRecipe } from '@chakra-ui/react';

export const gpsCoordinatesFieldRecipe = defineSlotRecipe({
  className: 'gps-coordinates',
  slots: ['root', 'unitSelector', 'positionPicker', 'input'],
  base: {
    root: {
      display: 'flex',
      width: '100%',
      height: 'auto',
    },
    unitSelector: {
      width: '110px',
      height: '48px',
    },
    positionPicker: {
      width: '48px',
      height: '48px',
      borderRadius: 'none',
      border: '2px solid',
      borderColor: 'neutral.black',
      backgroundColor: 'neutral.800',
      color: 'neutral.300',
      _hover: {
        borderColor: 'skyblue',
        color: 'skyblue',
      },
    },
    input: {
      width: '100%',
      height: '48px',
      _invalid: {
        borderColor: 'red',
        backgroundColor: 'red.800',
      },
    },
  },
});
